import { render, staticRenderFns } from "./ActivityInsert.vue?vue&type=template&id=2ea0bf10&scoped=true&"
import script from "./ActivityInsert.vue?vue&type=script&lang=js&"
export * from "./ActivityInsert.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInsert.vue?vue&type=style&index=0&id=2ea0bf10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea0bf10",
  null
  
)

export default component.exports